var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.getEvent}},[_vm._t("default",function(){return [_vm._v("Add event")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }